/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Drawer_SaveInputs */

const en_directory_submit_drawer_save = /** @type {(inputs: Directory_Submit_Drawer_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save & close`)
};

const zh_directory_submit_drawer_save = /** @type {(inputs: Directory_Submit_Drawer_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存并关闭`)
};

/**
* | output |
* | --- |
* | "Save & close" |
*
* @param {Directory_Submit_Drawer_SaveInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_drawer_save = /** @type {((inputs?: Directory_Submit_Drawer_SaveInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Drawer_SaveInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_drawer_save(inputs)
	return zh_directory_submit_drawer_save(inputs)
});
export { directory_submit_drawer_save as "directory.submit.drawer.save" }